export const PANEL_WIDTH = 404;
// Figma "Product Image" region: white area with the product photo (296×296)
// centered horizontally and offset 40px from the top.
export const IMAGE_SIZE = 296;
export const IMAGE_TOP_OFFSET = 40;
export const IMAGE_AREA_HEIGHT = IMAGE_SIZE + IMAGE_TOP_OFFSET; // 336
// Brand logo (24px) + 8px gap. Price / shipping / reward are indented by this
// so they line up under the brand name, leaving the logo alone in the gutter.
export const BRAND_GUTTER = 32;

export const FIGMA_YELLOW = '#FFBD32';
export const CHIP_BG = '#F6F8FA';
export const DIVIDER = '#E8E8ED';
// Inherit the brand theme's foreground/muted colors (published as CSS vars by
// the theme loader) instead of hardcoding black, so panel text matches the
// product card exactly. Fallbacks mirror the card's (`--bc-foreground` /
// `--bc-muted`) for non-themed contexts.
export const INK = 'var(--bc-foreground, #000000)';
export const MUTED = 'var(--bc-muted, rgba(0, 0, 0, 0.3))';
